import { useRef } from 'react';

import { Image } from '../../../snippets';
import { useGlobalContext } from '../../../contexts';

export function useOpenMediaModal() {
  const {
    actions: { openModal },
  } = useGlobalContext();

  const modalRef = useRef(null);

  const handleModal = async ({
    imageSrc,
    videoSources,
    openInFullscreen,
    altText,
  }) => {
    let videoSource = null;
    if (videoSources?.length) {
      videoSource = videoSources.find((source) => source.format === 'mp4');
    }

    // example modal
    await openModal(
      <div ref={modalRef}>
        {imageSrc && (
          <div className="p-6">
            <div className="modal-image-wrapper relative flex aspect-video h-[40rem] w-full max-w-[1200px] items-center justify-center">
              <Image
                alt={altText || 'Image Preview'}
                fill
                sizes="(min-width: 1440px) 900px, (min-width: 768px) 50vw, 100vw"
                className="!object-contain mix-blend-multiply"
                src={imageSrc}
              />
            </div>
          </div>
        )}
        {videoSource && (
          <div className="modal-video-wrapper w-[1920px] max-w-full">
            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
            <video autoPlay controls className="h-full w-full object-cover">
              <source src={videoSource?.url} type="video/mp4" />
            </video>
          </div>
        )}
      </div>
    );

    if (videoSource && openInFullscreen) {
      const video = modalRef.current.querySelector('video');

      if (!video) {
        console.error('Video element not found in modal');
        return;
      }

      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if (video.mozRequestFullScreen) {
        video.mozRequestFullScreen();
      } else if (video.webkitRequestFullscreen) {
        video.webkitRequestFullscreen();
      } else if (video.msRequestFullscreen) {
        video.msRequestFullscreen();
      }
    }
  };

  return {
    handleModal,
  };
}
